import { LEDModes } from "@aura-frontend/omnibus-az-client";

// The default state: a `null` LED mode, meaning no LED entitlements are active.
export const STANDBY_LABEL = "Standby";

export const LedModesLabels: Record<LEDModes, string> = {
  blocked: "Blocked",
  stat_tracking: "Prepay Stat Tracking & ABS Challenge System Only",
  umpire_assist: "Prepay Stat Tracker + Automatic Umpire",
};
